<template>
  <div>

    <b-container fluid class="header noselect">
      <b-row>
        <!-- Menu -->
        <b-col cols="2" class="d-lg-none text-left" align-self="center">
          <p class="logout m-0" @click="showMenu = !showMenu">
            <icon scale="1" name="bars"></icon>
          </p>
        </b-col>
       <!-- Logo -->
        <b-col cols="8" lg="2">
          <img class="p-2 mb-1 rounded-bottom logo mx-auto d-block" src="../../assets/img/easytick_color.png">
        </b-col>
        <!-- Sair Mobile -->
        <b-col cols="2" align-self="center" class="py-1 d-lg-none text-right">
          <p class="logout m-0">
            <router-link :to="{ name: 'Logout' }">
              <icon scale="1" name="power-off"></icon>
            </router-link>
          </p>
        </b-col>

        <b-col cols="12" lg="8" align-self="center" class="my-2">
          <h1 class="title text-center m-0">
            {{ pageTitle }}
          </h1>
        </b-col>

        <!-- Sair Desktop -->
        <b-col lg="2" align-self="center" class="py-1 d-none d-lg-block text-right">
          <p class="logout m-0">
            <router-link :to="{ name: 'Logout' }">
              <icon scale="1" name="power-off"></icon>
            </router-link>
          </p>
        </b-col>


      </b-row>
    </b-container>

    <b-container fluid>
      <b-row>
        <b-col cols="12" lg="2" v-if="showMenu" class="noselect mmenu pt-4">

          <h1>Operações</h1>
          <b-nav vertical class="mb-4 mt-1 rounded">
            <b-nav-item :to="{ name: 'CreateEventV2' }">
              <icon scale="0.9" name="plus"></icon> Criar
            </b-nav-item>
            <b-nav-item :to="{ name: 'Events' }">
              <icon scale="0.9" name="music"></icon> Gerenciar eventos
            </b-nav-item>
            <b-nav-item :to="{ name: 'Fichas' }">
              <icon scale="0.9" name="coins"></icon> Gerenciar fichas
            </b-nav-item>
          </b-nav>

          <h1>Relatórios</h1>
          <b-nav vertical class="mb-4 mt-1 rounded">
            <b-nav-item :to="{ name: 'AdminCreateGroupedReport' }">
              <icon scale="0.9" name="plus"></icon> Criar
            </b-nav-item>
            <b-nav-item :to="{ name: 'AdminGroupedReportList' }">
              <icon scale="0.9" name="tools"></icon> Gerenciar relatórios
            </b-nav-item>
          </b-nav>

          <h1>Loja Virtual</h1>
          <b-nav vertical class="mb-4 mt-1 rounded">
            <b-nav-item :to="{ name: 'Orders' }">
              <icon scale="0.9" name="store"></icon> Pedidos
            </b-nav-item>
            <b-nav-item :to="{ name: 'FinancialStatements' }">
              <icon scale="0.9" name="cash-register"></icon> Extrato Financeiro
            </b-nav-item>
            <b-nav-item :to="{ name: 'AdminOrdersResent' }">
              <icon scale="0.9" name="sync"></icon> Pedidos reenviados
            </b-nav-item>
          </b-nav>

          <h1>Termos</h1>
          <b-nav vertical class="mb-4 mt-1 rounded">
            <b-nav-item :to="{ name: 'AdminTermsCreate' }">
              <icon scale="0.9" name="plus"></icon> Criar
            </b-nav-item>
            <b-nav-item :to="{ name: 'AdminTermsList' }">
              <icon scale="0.9" name="file-contract"></icon> Gerenciar termos
            </b-nav-item>
          </b-nav>

          <h1>Usuários</h1>
          <b-nav vertical class="mb-4 mt-1 rounded">
            <b-nav-item :to="{ name: 'AdminUsersNew' }">
              <icon scale="0.9" name="plus"></icon> Criar
            </b-nav-item>
            <b-nav-item :to="{ name: 'AdminUsersList' }">
              <icon scale="0.9" name="tools"></icon> Gerenciar usuários
            </b-nav-item>
          </b-nav>

          <h1>Dados Restritos</h1>
          <b-nav vertical class="mb-4 mt-1 rounded">
            <b-nav-item :to="{ name: 'AdminDataRestrictions' }">
              <icon scale="0.9" name="ban"></icon> Gerenciar dados restritos
            </b-nav-item>
          </b-nav>

          <h1>Integrações MCP</h1>
          <b-nav vertical class="mb-4 mt-1 rounded">
            <b-nav-item :to="{ name: 'AdminMcpTokens' }">
              <icon scale="0.9" name="key"></icon> Tokens de acesso MCP
            </b-nav-item>
          </b-nav>
        </b-col>

        <b-col cols="12" lg="10" class="pt-3" style="min-height: calc(100vh - 95.17px)">
          <router-view/>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid class="footer">
      <b-row>
        <b-col>
          <p class="text-center my-2"><strong>Easytick</strong>, desde 2017 🎉</p>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import OrganizerMenu from './../organizer/OrganizerMenu'

export default {
  name: 'Dashboard',
  components: {
    'organizer-menu': OrganizerMenu
  },
  data () {
    return {
      showMenu: true,
      routeContext: null
    }
  },
  watch: {
    '$route' (to) {
      if (to.meta && to.meta.contextTitle) {
        this.routeContext = this.$session.get(`${to.name}Context`) || null
      } else {
        this.routeContext = null
      }
    }
  },
  computed: {
    pageTitle () {
      return this.routeContext || 'Administrador'
    }
  },
  created () {
    const logged = this.$session.get('logged')
    if (!logged) {
      return this.$router.push({name: 'Login'})
    }

    // const currentRoute = this.$router.currentRoute
    // const role = this.$session.get('role')

    // if (role === 'organizer' && currentRoute.name !== 'OrganizerEvents') {
    //   return this.$router.push({name: 'OrganizerEvents'})
    // } else if (role === 'admin' && currentRoute.name !== 'Events') {
    //   return this.$router.push({name: 'Events'})
    // }
  },
  methods: {
    logout () {
      this.$http.get(process.env.VUE_APP_URL_APP + '/b/logout').then(resp => {
        this.$router.push({name: 'Login'})
      }, err => {
        alert(err.body.error_description)
      })
    }
  }
}
</script>
